import React, { useState } from "react";
import { Box, Divider } from "@mui/material";
import CartLoader from "../../../Helper/Loaders/CartLoader";
import { BmsFaultsAnalyticsContainer } from "../../BmsFaults/Components/StyledComponents";
import { usePagesContent } from "../../../Hooks/usePagesContent";
import AnalyticsKPISection from "./AnalyticsKPISection";
import SmartAlertsTrends from "./SmartAlertsTrends";
import SmartAlertsChartDetailsView from "./SmartAlertsChartDetailsView";
import MostCriticalVehiclesTable from "./MostCriticalVehiclesTable";

const SmartAlertsAnalytics = ({
  startDate,
  endDate,
  vehiclesConnected,
  isLoadingVehiclesCount,
  globalFilters,
  allFleets,
  allOnboardingLocationsHierarchy,
  onDetailsViewChange,
}) => {
  const pagesContent = usePagesContent();
  const [showChartDetails, setShowChartDetails]     = useState(false);
  const [selectedChartType, setSelectedChartType]   = useState(null);
  const [selectedGranularity, setSelectedGranularity] = useState("Weekly");

  const handleShowDetails = (chartType, granularity) => {
    setSelectedChartType(chartType);
    setSelectedGranularity(granularity);
    setShowChartDetails(true);
    if (onDetailsViewChange) onDetailsViewChange(true);
  };

  const handleBack = () => {
    setShowChartDetails(false);
    if (onDetailsViewChange) onDetailsViewChange(false);
  };

  // Render loading state until pagemeta is fully fetched
  if (!pagesContent?.mounted) {
    return (
      <BmsFaultsAnalyticsContainer>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "400px" }}>
          <CartLoader />
        </Box>
      </BmsFaultsAnalyticsContainer>
    );
  }

  if (showChartDetails) {
    return (
      <BmsFaultsAnalyticsContainer>
        <SmartAlertsChartDetailsView
          chartType={selectedChartType}
          startDate={startDate}
          endDate={endDate}
          initialGranularity={selectedGranularity}
          globalFilters={globalFilters}
          allFleets={allFleets}
          allOnboardingLocationsHierarchy={allOnboardingLocationsHierarchy}
          onBack={handleBack}
        />
      </BmsFaultsAnalyticsContainer>
    );
  }

  return (
    <BmsFaultsAnalyticsContainer>
      {/* KPI Section */}
      <AnalyticsKPISection
        startDate={startDate}
        endDate={endDate}
        globalFilters={globalFilters}
        vehiclesConnected={vehiclesConnected}
        isLoadingVehiclesCount={isLoadingVehiclesCount}
      />

      <Divider sx={{ my: 2, borderColor: "#E6E6E6" }} />

      <SmartAlertsTrends
        onShowDetails={handleShowDetails}
        startDate={startDate}
        endDate={endDate}
        globalFilters={globalFilters}
      />

      <Divider sx={{ my: 2, borderColor: "#E6E6E6" }} />

      <MostCriticalVehiclesTable
        startDate={startDate}
        endDate={endDate}
        globalFilters={globalFilters}
      />
    </BmsFaultsAnalyticsContainer>
  );
};

export default SmartAlertsAnalytics;
